/* eslint-disable max-len */

import {
  faCar,
  faBomb,
  faSkull,
  faSkullCrossbones,
  faCarCrash,
  faInfoCircle,
  faHouseDamage,
  faCloudShowersHeavy,
  faCogs,
  faBalanceScale,
  faFileSignature,
  faUserShield,
  faUserTie,
  faMoneyCheckAlt,
  faShieldAlt,
  faKey,
  faTaxi,
  faNotesMedical,
  faAdjust,
  faUserMd,
  faCertificate,
  faFileInvoice,
  faUserInjured,
  faCarSide,
  faFire,
  faFireExtinguisher,
  faUserNinja,
  faPeopleCarry,
  faTruck,
  faWindowClose,
  faCashRegister,
  faTrafficLight,
  faCreditCard,
  faShoppingBag,
  faFileInvoiceDollar,
  faChargingStation,
  faSuitcase,
  faHeartBroken,
  faHotel,
  faHamburger,
  faUnlock,
  faWrench,
  faWheelchair,
  faCommentMedical,
  faFileMedical,
  faArrowDown91,
  faUserClock,
  faEnvelopesBulk,
  faPaintbrush,
  faWallet,
  faBoltLightning,
  faFaucet,
  faToilet,
  faChild,
  faReceipt,
  faAward,
  faPercent,
  faTruckRampBox,
  faThumbsDown,
  faFaceSadTear,
  faFireFlameCurved,
  faAddressCard,
  faTruckPickup
} from '@fortawesome/free-solid-svg-icons'

import { COVERAGE } from 'Global/constants'

import cardInsuranceCar from 'Assets/card_insurance_car.jpg'
import cardInsuranceLife from 'Assets/card_insurance_life.png'
import cardInsuranceHome from 'Assets/card_insurance_home.png'
import cardInsuranceBuilding from 'Assets/card_insurance_building.png'

export const PRODUCTS = {
  1: {
    img: cardInsuranceCar,
    icon: faCarCrash,
    description: 'Cotizá aquí el seguro para tu vehículo en 1 minuto.'
  },
  2: {
    img: cardInsuranceHome,
    icon: faHouseDamage,
    description: 'Cotizá aquí el seguro para tu vehículo en 1 minuto. Compare, contrate y obtenga su póliza en menos de 8 minutos.'
  },
  3: {
    img: cardInsuranceCar,
    icon: faCarCrash,
    description: 'Cotizá aquí el seguro para tu vehículo en 1 minuto. Compare, contrate y obtenga su póliza en menos de 8 minutos.'
  },
  4: {
    img: cardInsuranceCar,
    icon: faCarCrash,
    description: 'Cotizá aquí el seguro para tu vehículo en 1 minuto. Compare, contrate y obtenga su póliza en menos de 8 minutos.'
  },
  5: {
    img: cardInsuranceCar,
    icon: faCarCrash,
    description: 'Cotizá aquí el seguro para tu vehículo en 1 minuto. Compare, contrate y obtenga su póliza en menos de 8 minutos.'
  },
  6: {
    img: cardInsuranceBuilding,
    icon: faBomb,
    description: 'Cotizá aquí el seguro para tu vehículo en 1 minuto. Compare, contrate y obtenga su póliza en menos de 8 minutos.'
  },
  7: {
    img: cardInsuranceCar,
    icon: faCarCrash,
    description: 'Cotizá aquí el seguro para tu vehículo en 1 minuto. Compare, contrate y obtenga su póliza en menos de 8 minutos.'
  },
  8: {
    img: cardInsuranceCar,
    icon: faCarCrash,
    description: 'Cotizá aquí el seguro para tu vehículo en 1 minuto. Compare, contrate y obtenga su póliza en menos de 8 minutos.'
  },
  9: {
    img: cardInsuranceLife,
    icon: faSkull,
    description: 'Cotizá aquí el seguro para tu vehículo en 1 minuto. Compare, contrate y obtenga su póliza en menos de 8 minutos.'
  }
}
// lista de iconos para comparar con BE
export const METADATAICONS = [
  {
    id: 'vehicular_assistance',
    icon: faTruckPickup
  },
  {
    id: 'hail_damage',
    icon: faCloudShowersHeavy
  },
  {
    id: 'available_drivers',
    icon: faUserShield
  },
  {
    id: 'accident_lawyer',
    icon: faUserTie
  },
  {
    id: 'registered_liability',
    icon: faMoneyCheckAlt
  },
  {
    id: 'glasses_repair',
    icon: faShieldAlt
  },
  {
    id: 'locksmith_repair',
    icon: faKey
  },
  {
    id: 'medical_expenses_in_accident',
    icon: faNotesMedical
  },
  {
    id: 'light_adjustment',
    icon: faAdjust
  },
  {
    id: 'original_replacements',
    icon: faCogs
  },
  {
    id: 'legal_assistance',
    icon: faBalanceScale
  },
  {
    id: 'notarial_expenses_for_total_loss',
    icon: faFileSignature
  },
  {
    id: 'green_card',
    icon: faAddressCard
  },
  {
    id: 'soa',
    icon: faFileInvoice
  },
  {
    id: 'courtesy_vehicle',
    icon: faCar
  },
  {
    id: 'courtesy_vehicle_for_theft',
    icon: faCarSide
  },
  {
    id: 'civil_liability_coverage_amount',
    icon: faUserInjured
  },
  {
    id: 'personal_accidents',
    icon: faUserInjured
  },
  {
    id: 'building_fire',
    icon: faFireExtinguisher
  },
  {
    id: 'content_fire',
    icon: faFire
  },
  {
    id: 'content_theft',
    icon: faUserNinja
  },
  {
    id: 'civil_liability',
    icon: faPeopleCarry
  },
  {
    id: 'debris_removal',
    icon: faTruck
  },
  {
    id: 'rents_loss',
    icon: faHouseDamage
  },
  {
    id: 'broken_glasses',
    icon: faWindowClose
  },
  {
    id: 'atm_robbery',
    icon: faCashRegister
  },
  {
    id: 'robbery_in_public',
    icon: faTrafficLight
  },
  {
    id: 'credit_card_fraud',
    icon: faCreditCard
  },
  {
    id: 'keys_replacement',
    icon: faKey
  },
  {
    id: 'backpack_replacement',
    icon: faShoppingBag
  },
  {
    id: 'documents_expenses',
    icon: faFileInvoiceDollar
  },
  {
    id: 'theft_electrical_equipment',
    icon: faChargingStation
  },
  {
    id: 'bag_expenses',
    icon: faSuitcase
  },
  {
    id: 'theft_damages',
    icon: faHeartBroken
  },
  {
    id: 'lodging_expenses',
    icon: faHotel
  },
  {
    id: 'freezer_food',
    icon: faHamburger
  },
  {
    id: 'lock_combination_change',
    icon: faUnlock
  },
  {
    id: 'home_assistance',
    icon: faWrench
  },
  {
    id: 'accidental_death',
    icon: faSkull
  },
  {
    id: 'illness_death',
    icon: faSkullCrossbones
  },
  {
    id: 'permanent_total_disability',
    icon: faWheelchair
  },
  {
    id: 'second_medical_opinion',
    icon: faCommentMedical
  },
  {
    id: 'diary_rent',
    icon: faFileMedical
  },
  {
    id: 'capital_reduce',
    icon: faArrowDown91
  },
  {
    id: 'age_limit',
    icon: faUserClock
  },
  {
    id: 'credit_card_replacement',
    icon: faEnvelopesBulk
  },
  {
    id: 'cosmetics',
    icon: faPaintbrush
  },
  {
    id: 'wallet',
    icon: faWallet
  },
  {
    id: 'electric_damages',
    icon: faBoltLightning
  },
  {
    id: 'water_damages',
    icon: faFaucet
  },
  {
    id: 'sanitary_equipment',
    icon: faToilet
  },
  {
    id: 'childich_retention',
    icon: faChild
  },
  {
    id: 'mobility_expenses',
    icon: faReceipt
  },
  {
    id: 'repairment_after_year',
    icon: faAward
  },
  {
    id: 'deductible_discount',
    icon: faPercent
  },
  {
    id: 'trunk_theft',
    icon: faTruckRampBox
  },
  {
    id: 'total_loses',
    icon: faThumbsDown
  },
  {
    id: 'total_theft',
    icon: faFaceSadTear
  },
  {
    id: 'total_fire',
    icon: faFireFlameCurved
  },
  {
    id: 'mercosur_certifcate',
    icon: faCertificate
  },
  {
    id: 'accident_remise',
    icon: faCarCrash
  },
  {
    id: 'zero_km_replacement',
    icon: faTaxi
  }

]

export const COVERAGE_MAPPING = {
  [COVERAGE.BASIC]: 'Responsabilidad Civil',
  [COVERAGE.MEDIUM]: 'Cobertura Triple',
  [COVERAGE.TOTAL]: 'Cobertura Todo Riesgo'
}
